import './../../dist/templates/templates';

import './libraries/keyboard/custom_layouts/customnum.min';
import './libraries/keyboard/custom_layouts/customnumwithpoint.min';
import './libraries/keyboard/custom_layouts/customwebco.min';

import config from './angular/config/index';
import run from './angular/run';

import './angular/directives/index';

import './angular/modules/login/login';
import './angular/modules/packaging/packaging';

const App = angular.module('myApp', [
    'ngRoute',
    'ngCookies',
    'ngAnimate',
    'ngFlash',
    'wco.directives',
    'myApp.login',
    'myApp.packaging',
    'templates',
    'angular-loading-bar',
]);

App.config(config);
App.run(run);